import { createAction, props } from '@ngrx/store'
import { InitialiseData } from '../../models/state.model'
import { SelectedCompanyAPIModel } from 'src/app/models/api.model'

export const start_initializing = createAction('[initialize] start_initializing', props<{ comingFromLogin: boolean }>())
export const initialize_success = createAction(
  '[initialize] initialize_success',
  props<{ initializeData: InitialiseData; comingFromLogin: boolean }>()
)
export const initialize_failed = createAction('[initialize] initialize_failed', props<any>())
export const clear_initialize_data = createAction('[initialize] clear_initialize_data')

export const save_selected_companies = createAction(
  '[initialize] save_selected_companies',
  props<{ selectedCompanies: SelectedCompanyAPIModel[] }>()
)

export const update_password_auto_generated = createAction('update_password_auto_generated', props<{ val: boolean }>())
